import { PetitionTypes } from './../../models/petition-types';
import { AbsenceMotives } from './../../models/absence-motives';
import { PetitionProvider } from './../petition/petition';
import { UserProvider } from './../user/user';
import { Injectable } from '@angular/core';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { Platform } from 'ionic-angular';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import { FirebaseProvider } from '../firebase/firebase';
import { GlobalVars } from '../../app/app.environment';
import { User } from '../../models/user';
import { Petition } from '../../models/petition';

pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Injectable()
export class ReportProvider {

  private monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
 
  constructor(
    public platform: Platform,
    public file: File,
    public fileOpener: FileOpener,
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
    public petitionProvider: PetitionProvider,
    public userProvider: UserProvider
  ) {}

  userReport(period: number, selectedUser: User, relativeTime: boolean): any {
    return new Promise((resolve, reject) => {
      var userAPs = [];
      var userMedical = [];
      var userHolidays = [];
      var userHourCompensation = [];
      var userExtraHours = [];
  
      this.petitionProvider.getUserAcceptedByPeriodOnce(period, selectedUser.key).subscribe(petitions => {
        console.log(petitions)
  
        petitions.forEach(petition => {
  
          if(petition.state == 'Aceptado') {
            if(petition.motiveKey == AbsenceMotives.APs) {
              petition.date = (new Date(petition.date)).toLocaleDateString();
              userAPs.push(petition);      
            }
            
            else if(petition.motiveKey == AbsenceMotives.holidays) {
              petition.beginDate = (new Date(petition.beginDate)).toLocaleDateString();
              petition.endDate = (new Date(petition.endDate)).toLocaleDateString();
              userHolidays.push(petition);
            }
  
            else if(petition.motiveKey == AbsenceMotives.medical) {
              petition.date = (new Date(petition.date)).toLocaleDateString();
              userMedical.push(petition);
            }
            else if(petition.typeId == PetitionTypes.extraHours) {
              petition.date = (new Date(petition.date)).toLocaleDateString();
              userExtraHours.push(petition);
            }
            else if(petition.typeId == PetitionTypes.hourCompensation) {
              petition.beginDate = (new Date(petition.beginDate)).toLocaleDateString();
              petition.endDate = (new Date(petition.endDate)).toLocaleDateString();
              userHourCompensation.push(petition);
            }
          }
          
          return false;
        });
        
  
        // Inicialització del document
        var docDefinition = {
          header: { text: `Resumen: ${selectedUser.name}`, style: 'header' },
          
          content: [],
    
          styles: {
            header: {
              fontSize: 22,
              bold: true,
              alignment: 'center',
              margin: [0, 10]
            },
            table: {
              margin: [0, 20, 0, 0]
            }
          }
        };
  
        var total;
  
  
        // Afegir APs
        docDefinition.content.push({
          table: {
            headerRows: 2,
            widths: [ 100, 50, '*' ],
  
            body: [
              [{text: 'Asuntos propios', colSpan: 3, alignment: 'center', bold: true, fontSize: 16}, {}, {}],
              [{text: 'Fecha', bold: true}, {text: 'Cálculo', alignment: 'right', bold: true}, {text: 'Comentarios', bold: true}]
            ]
          },
          style: 'table'
        });
  
        if(userAPs.length == 0) {
          docDefinition.content[0].table.body.push([ 
            { text: '---' }, 
            { text: '---',            alignment: 'right' },
            { text: '---' },
          ])
        }
  
        else {
          total = 0;
  
          userAPs.forEach(AP => {
            docDefinition.content[0].table.body.push([ 
              { text: AP.date     }, 
              { text: '1',        alignment: 'right' },
              { text: AP.comments },
            ]);
  
            total += 1;
          });
  
          docDefinition.content[0].table.body.push([ 
            { text: 'Total', bold: true }, 
            { text: total,   bold: true, alignment: 'right' },
            { },
          ]);
        }
  
  
        // Afegir metge
        docDefinition.content.push({  
          table: {
            headerRows: 2,
            widths: [ 100, 50, '*' ],
  
            body: [
              [{text: 'Médico', colSpan: 3, alignment: 'center', bold: true, fontSize: 16}, {}, {}],
              [{text: 'Fecha', bold: true}, {text: 'Cálculo', alignment: 'right', bold: true}, {text: 'Comentarios', bold: true}]
            ]
          },
          style: 'table'
        });
  
        if(userMedical.length == 0) {
          docDefinition.content[1].table.body.push([ 
            { text: '---' }, 
            { text: '---', alignment: 'right' },
            { text: '---' },
          ])
        }
  
        else {
          total = 0;
  
          userMedical.forEach(medical => {
            docDefinition.content[1].table.body.push([ 
              { text: medical.date     }, 
              { text: '1',             alignment: 'right' },
              { text: medical.comments },
            ]);
  
            total += 1;
          });
  
          docDefinition.content[1].table.body.push([ 
            { text: 'Total', bold: true }, 
            { text: total,   bold: true, alignment: 'right' },
            { },
          ]);
        }
  
  
        // Afegir vacances
        docDefinition.content.push({
          table: {
            headerRows: 2,
            widths: [ 70, 70, 50, '*' ],
  
            body: [
              [{text: 'Vacaciones', colSpan: 4, alignment: 'center', bold: true, fontSize: 16}, {}, {}, {}],
              [{text: 'Fecha inicio', bold: true}, {text: 'Fecha final', bold: true}, {text: 'Cálculo', alignment: 'right', bold: true}, {text: 'Comentarios', bold: true}]
            ]
          },
          style: 'table'
        });
  
        if(userHolidays.length == 0) {
          docDefinition.content[2].table.body.push([ 
            { text: '---' },
            { text: '---' },
            { text: '---', alignment: 'right' },
            { text: '---' },
          ])
        }
  
        else {
          total = 0;
  
          userHolidays.forEach(holiday => {
            docDefinition.content[2].table.body.push([ 
              { text: holiday.beginDate }, 
              { text: holiday.endDate   }, 
              { text: holiday.workDays, alignment: 'right' },
              { text: holiday.comments  },
            ]);
  
            total += holiday.workDays
          });
  
          docDefinition.content[2].table.body.push([ 
            { text: 'Total', bold: true, colSpan: 2 },
            { },
            { text: total,   bold: true, alignment: 'right' },
            { },
          ]);
        }
  
  
        // Afegir hores extra
        docDefinition.content.push({
          table: {
            headerRows: 2,
            widths: [ 70, 50, 70, 50, '*' ],
  
            body: [
              [{text: 'Horas extra', colSpan: 5, alignment: 'center', bold: true, fontSize: 16}, {}, {}, {}, {}],
              [{text: 'Fecha', bold: true}, {text: 'Horas', bold: true, alignment: 'right'}, {text: 'Coeficiente', bold: true}, {text: 'Total', bold: true, alignment: 'right'}, {text: 'Comentarios', bold: true}]
            ]
          },
          style: 'table'
        });
  
        if(userExtraHours.length == 0) {
          docDefinition.content[3].table.body.push([ 
            { text: '---'  },
            { text: '---', alignment: 'right' },
            { text: '---'  },
            { text: '---', alignment: 'right' },
            { text: '---'  },
          ])
        }
  
        else {
          total = 0;
  
          userExtraHours.forEach(extraHours => {
            docDefinition.content[3].table.body.push([ 
              { text: extraHours.date }, 
              { text: extraHours.quantity, alignment: 'right' }, 
              { text: extraHours.coefficientName },
              { text: extraHours.totalHours, alignment: 'right' }, 
              { text: extraHours.comments },
            ]);
  
            total += extraHours.totalHours;
          });
  
          docDefinition.content[3].table.body.push([ 
            { text: 'Total', bold: true, colSpan: 3 },
            { },
            { },
            { text: total,   bold: true, alignment: 'right' },
            { },
          ]);
        }
        
  
        // Afegir compensació hores
        docDefinition.content.push({
          table: {
            headerRows: 2,
            widths: [ 70, 70, 50, '*' ],
  
            body: [
              [{text: 'Compensación de horas', colSpan: 4, alignment: 'center', bold: true, fontSize: 16}, {}, {}, {}],
              [{text: 'Fecha inicio', bold: true}, {text: 'Fecha final', bold: true}, {text: 'Horas', bold: true, alignment: 'right'}, {text: 'Comentarios', bold: true}]
            ]
          },
          style: 'table'
        });
  
        if(userHourCompensation.length == 0) {
          docDefinition.content[4].table.body.push([ 
            { text: '---' },
            { text: '---' },
            { text: '---',          alignment: 'right' },
            { text: '---' },
          ])
        }
  
        else {
          total = 0;
  
          userHourCompensation.forEach(compensation => {
            docDefinition.content[4].table.body.push([ 
              { text: compensation.beginDate },
              { text: compensation.endDate },
              { text: compensation.compensationHours, alignment: 'right' }, 
              { text: compensation.comments },
            ]);
  
            total += Number(compensation.compensationHours);
          });
  
          docDefinition.content[4].table.body.push([ 
            { text: 'Total', bold: true, colSpan: 2 },
            { },
            { text: total,   bold: true, alignment: 'right' },
            { },
          ]);
        }
        
        console.log(docDefinition);
  
        this.makePdf(docDefinition, 'Resumen_usuario')
          .then(() => resolve(true))
          .catch(error => reject(error))
      })  
    })
  }

  globalReport(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.userProvider.getUsersOnce().subscribe(users => {
        
        var docDefinition = {
          header: { text: 'Resumen global', style: 'header' },
          
          content: [
            {
              table: {
                headerRows: 1,
                widths: [ '*', 'auto', 65, 65, 65 ],

                body: [
                  [ { text: 'Nombre',                 bold: true }, 
                    { text: 'Área',                   bold: true }, 
                    { text: 'Horas extra',            bold: true }, 
                    { text: 'APs pendientes',         bold: true }, 
                    { text: 'Vacaciones pendientes',  bold: true } 
                  ],
                ]
              },
              style: 'table'
            }
          ],

          styles: {
            header: {
              fontSize: 22,
              bold: true,
              alignment: 'center',
              margin: [0, 10]
            },
            table: {
              margin: [0, 20, 0, 0]
            }
          }
        };

        users.forEach(user => {
          if(user.pendingAPs != null && user.pendingHolidays != null && user.extraHours != null) {
            var pendingHolidays = user.pendingHolidays[this.globalVars.currentPeriod];
            var pendingAPs = user.pendingAPs[this.globalVars.currentPeriod];
    
            docDefinition.content[0].table.body.push([ 
              { text: user.name || '',              bold: false }, 
              { text: user.area || '',              bold: false }, 
              { text: user.extraHours || '',        bold: false }, 
              { text: pendingAPs || '',             bold: false }, 
              { text: pendingHolidays || '',        bold: false },
            ])  
          }
        })

        console.log(docDefinition)

        this.makePdf(docDefinition, 'Resumen_global.pdf')
          .then(() => resolve(true))
          .catch(error => reject(error))
      })
    })
  }

  monthReport(selectedAreas, beginMonth, endMonth) {
    return new Promise((resolve, reject) => {
    
      this.userProvider.getUsersOnce().subscribe(users => {

        var usersList = [];
        var userAreas = [];

        users.forEach(user => {
          if(selectedAreas.filter(area => area.key == user.areaId).length > 0) {
            usersList.push({ key: user.key, name: user.name });
            userAreas[user.key] = user.area;
          }
        });

        if(usersList != []) {
          var curMonth = new Date(beginMonth);
        
          var finalMonth = new Date(endMonth)
          var monthDays = new Date(finalMonth.getFullYear(), finalMonth.getMonth()+1, 0).getDate();
          finalMonth = new Date(finalMonth.getFullYear(), finalMonth.getMonth(), monthDays, 1, 0, 0, 0);
  
      
          // Inicialització del document
          var documentPDF = {
            header: { text: 'Resumen por meses', style: 'header' },
            
            content: [],
      
            styles: {
              header: {
                fontSize: 22,
                bold: true,
                alignment: 'center',
                margin: [0, 10],
              },
              table: {
                margin: [0, 2, 0, 20],
                fontSize: 9,
              },
              tableHeader: {
                bold: true,
                fontSize: 20,
              },
              tableSubHeader: {
                bold: true,
                fontSize: 12,
              }
            },
      
            pageOrientation: 'landscape',
            pageMargins: [ 10, 50, 10, 20 ],
          };
  
          var userPetitions = {};
          var tempUserList = usersList.slice(0);
  
          this.loadUserPetitions(tempUserList, userPetitions).then(userPetitions => {
            
            if(userPetitions != {}) {
              var monthTable = [];
              var userNumber = 0;
              var months = [];

              console.log(userPetitions)
              console.log(usersList)
    
              usersList.forEach(user => {
                var petitions = userPetitions[user.key];
                var busyDays = {}; // Tots el dies ocupats d'aquell usuari (tots els mesos i anys)
        
                console.log(petitions.slice())

                petitions.forEach(petition => {
                  
                  if(petition.state == 'Aceptado' && petition.annulment == false) {
                    this.fillDays(busyDays, petition);
                  }
            
                  else if(petition.state == 'Aceptado' && petition.annulment == true) {
                    this.emptyDays(busyDays, petition);
                  }
                })
                
                console.log(busyDays)
                
                var userBusyDays = busyDays[user.key]
                console.log(userBusyDays)
    
                for(let i=0; userBusyDays && i < userBusyDays.length; i++) {
                  
                  var curDate = new Date(curMonth.getFullYear(), curMonth.getMonth(), 1, 1, 0, 0, 0);
    
                  console.log(curDate)
                  console.log(finalMonth)

                  var num = 0;
    
                  // Iterar sobre cada mes
                  while(curDate < finalMonth) {
                    
                    var filaUsuari = [];
                    if(monthTable[num] == null) monthTable[num] = [];
    
                    months.push(new Date(curDate))
    
                    filaUsuari.push({ text: user.name, bold: true, alignment: 'left'});
                    filaUsuari.push({ text: userAreas[user.key], bold: false, alignment: 'left'});
      
                    var diesMes = new Date(curDate.getFullYear(), curDate.getMonth()+1, 0).getDate();
                    var dataFinal = new Date(curDate.getFullYear(), curDate.getMonth(), diesMes, 1, 0, 0, 0);
                    
                    // Omplir dies de l'usuari
                    while (curDate <= dataFinal) {
                      var lletra = this.dateInDatesArray(curDate, userBusyDays);
                      filaUsuari.push({ text: lletra, bold: false, alignment: 'center'});
                      curDate.setDate(curDate.getDate() + 1);
                    }
      
                    monthTable[num][userNumber] = filaUsuari;
                    
                    num++;
                  }
                }
    
                userNumber++;
              })

              console.log(monthTable)
    
              for(let i=0; monthTable && i < monthTable.length; i++) {
    
                documentPDF.content.push(
                  { text: this.monthNames[months[i].getMonth()], style: 'tableHeader', alignment: 'left' },
            
                  {
                    table: {
                      headerRows: 1,
                      widths: [ '*', 'auto'],
      
                      body: [
                        [ { text: 'Nombre', bold: true, alignment: 'left' }, 
                          { text: 'Área',   bold: true, alignment: 'left' }
                        ]
                      ]
                    },
                    style: 'table',
                    pageBreak: 'after',
                  }
                )
    
                let key = Object.keys(monthTable[i])[0];
    
                for(let j=1; monthTable[i][key] && j <= monthTable[i][key].length - 2; j++) {
                  documentPDF.content[i*2+1].table.widths.push(12);
                  documentPDF.content[i*2+1].table.body[0].push({ text: j.toString(), bold: true, alignment: 'center' });
                }
    
                monthTable[i].forEach(line => {
                  documentPDF.content[i*2+1].table.body.push(line)
                })
              }
              
              console.log(documentPDF)

              if (documentPDF.content[documentPDF.content.length-1])
                documentPDF.content[documentPDF.content.length-1]['pageBreak'] = null;
    
              this.makePdf(documentPDF, 'Resumen_mensual.pdf')
              .then(() => resolve(true))
              .catch(error => reject(error));   
            }
            
            else {
              resolve(true)
            }
          })
        }

        else {
          resolve(true)
        }
      })
    })
  }

  /**
   * Funció recursiva per recuperar les peticions d'una 
   * llista d'usuaris mitjançant observables i promises.
   * 
   * @param tempUserList 
   * @param userPetitions 
   */
  private loadUserPetitions(tempUserList, userPetitions): Promise<any> {
    return new Promise(resolve => {
      if(tempUserList.length) {
        var user = tempUserList.pop();

        this.petitionProvider.getUserAcceptedOnce(user.key).subscribe(petitions => {
          userPetitions[user.key] = petitions;

          this.loadUserPetitions(tempUserList, userPetitions).then(userPetitions => {
            resolve(userPetitions);
          })
        })
      }

      else resolve(userPetitions);
    })
  }
  
  private fillDays(busyDays, petition: Petition) {
    
    if(busyDays[petition.userKey] == null) busyDays[petition.userKey] = []; 

    if (petition.typeId == PetitionTypes.hourCompensation || petition.motiveKey == AbsenceMotives.holidays) {
      
      var startDate = new Date(petition.beginDate);
      var endDate = new Date(petition.endDate);

      var curDate = startDate;
      while (curDate <= endDate) {

        if(petition.typeId == PetitionTypes.hourCompensation)
          busyDays[petition.userKey].push({ date: new Date(curDate), type: 'C' });
        
        else if(petition.motiveKey == AbsenceMotives.holidays)
          busyDays[petition.userKey].push({ date: new Date(curDate), type: 'V' });
          
        curDate.setDate(curDate.getDate() + 1);
      }
    }
    else {

      if(petition.motiveKey == AbsenceMotives.APs)
        busyDays[petition.userKey].push({ date: new Date(petition.date), type: 'AP' });

      else if(petition.motiveKey == AbsenceMotives.medical)
        busyDays[petition.userKey].push({ date: new Date(petition.date), type: 'M' });
    }
  }

  private emptyDays(diesOcupats, petition) {
    var curDate;
    
    if (petition.typeId == PetitionTypes.hourCompensation || petition.motiveKey == AbsenceMotives.holidays) {
      var startDate = new Date(petition.beginDate);
      var endDate = new Date(petition.endDate);
    
      curDate = startDate;
      while (curDate <= endDate) {
        if(petition.typeId == PetitionTypes.hourCompensation)
          diesOcupats[petition.userKey].splice(diesOcupats[petition.userKey].indexOf([curDate, 'C']),1);

        else if(petition.motiveKey == AbsenceMotives.holidays)
          diesOcupats[petition.userKey].splice(diesOcupats[petition.userKey].indexOf([curDate, 'V']),1);

        curDate.setDate(curDate.getDate() + 1);
      }
    }
    
    else {
      curDate = new Date(petition.date);

      if(petition.motiveKey == AbsenceMotives.APs)
        diesOcupats[petition.userKey].splice(diesOcupats[petition.userKey].indexOf([curDate, 'AP']),1);

      else if(petition.motiveKey == AbsenceMotives.medical)
        diesOcupats[petition.userKey].splice(diesOcupats[petition.userKey].indexOf([curDate, 'M']),1);
    }
  }

  private dateInDatesArray(data, array) {
    var result = ' ';
    
    array.forEach(element => {
      if(element.date.toDateString() == data.toDateString())
        result = element.type;
    });

    return result;
  }

  private makePdf(docDefinition, name): Promise<any> {
    var name = name.replace(' ', '_');

    if(this.platform.is('cordova')) {
      console.log('Mòbil')

      var directori;

      if(this.platform.is('android')) directori = this.file.externalRootDirectory;
      else if(this.platform.is('ios')) directori = this.file.documentsDirectory;

      return new Promise((resolve, reject) => {
        pdfMake.createPdf(docDefinition).getBlob(buffer => {
        this.file.resolveDirectoryUrl(directori)
          .then(dirEntry => {
            this.file.getFile(dirEntry, name, { create: true })
              .then(fileEntry => {
                fileEntry.createWriter(writer => {
                  writer.onwrite = () => {
                    this.fileOpener.open(fileEntry.toURL(), 'application/pdf')
                      .then(res => resolve(true))
                      .catch(err => reject(err));
                  }
                  writer.write(buffer);
                })
              }).catch(err => reject(err));
          }).catch(err => reject(err));
        })
      })
    }

    else {
      console.log('Navegador')

      try {
        pdfMake.createPdf(docDefinition).download(name)
        return Promise.resolve(true)
      }

      catch (error) {
        return Promise.reject(error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/report/report.ts